export const deviceConstants = {
  mobile: 'MOBILE',
  desktop: 'DESKTOP',
  tablet: 'TABLET',
  other: 'OTHER'
};

export const deviceDetailsConstants = {
  deviceType: 'device_type',
  deviceBrowserName: 'browser_name',
  deviceBrowserVersion: 'browser_version',
  deviceOSName: 'os_name',
  deviceOSVersion: 'os_version'
};
